(() => {
  if (document.documentElement.dataset.rexxInquiryReady) return;
  document.documentElement.dataset.rexxInquiryReady = 'true';
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-rexx-inspire]');
    if (!trigger) return;
    const anchor = document.getElementById('rexx-project-inquiry');
    const form = anchor?.closest('form');
    const field = form?.querySelector('[data-rexx-inspiration-field]');
    if (!field || !trigger.dataset.rexxInspire) return;
    event.preventDefault();
    const dialog = trigger.closest('dialog');
    if (dialog?.open) dialog.close();
    const projectName = trigger.closest('article')?.querySelector('h3')?.textContent?.trim()
      || trigger.closest('dialog')?.querySelector('figcaption')?.textContent?.trim()
      || trigger.dataset.rexxInspire;
    field.value = projectName.slice(0, 160);
    field.dispatchEvent(new Event('input', { bubbles: true }));
    const type = form.querySelector('[name="contact[Project type]"]');
    if (type && !type.value && trigger.dataset.rexxProjectType) {
      type.value = trigger.dataset.rexxProjectType;
      type.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const status = form.querySelector('[data-rexx-inspiration-status]');
    if (status) {
      status.textContent = `${status.dataset.prefix} ${field.value}`;
      status.hidden = false;
    }
    // Keep typed message and contact details intact. No storage, submission or analytics.
    anchor.scrollIntoView({ behavior: 'instant', block: 'start' });
    anchor.focus({ preventScroll: true });
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-rexx-inspiration-field]')) return;
    const status = event.target.closest('form').querySelector('[data-rexx-inspiration-status]');
    if (status) status.hidden = true;
  });
})();
